import { useInitialLoading } from '../hooks/useInitialLoading';
import React, { useState, useEffect, useCallback } from 'react';
import { getAuthHeaders } from '../utils/authHeaders';
import { API, tableStyle, thStyle, tdStyle, inputStyle, btnSecondary } from './RpShared';

export default function RpHistory() {
  const companyId = localStorage.getItem('selectedCompanyId');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const initialLoading = useInitialLoading(loading);
  const [filters, setFilters] = useState({ category: '', action: '', search: '', from: '', to: '' });
  const [page, setPage] = useState(1);

  const fetchHistory = useCallback(async () => {
    setLoading(true);
    try {
      const url = new URL(`${API}/companies/${companyId}/roles-permissions/history`);
      Object.entries(filters).forEach(([k, v]) => { if (v) url.searchParams.set(k, v); });
      url.searchParams.set('page', page);
      const res = await fetch(url, { headers: getAuthHeaders() });
      setData(await res.json());
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [companyId, filters, page]);

  useEffect(() => { fetchHistory(); }, [fetchHistory]);

  return (
    <div style={{ padding: '24px 32px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <h2 style={{ margin: '0 0 20px', fontSize: 22, fontWeight: 700, color: '#1a1a2e' }}>📜 Permission Audit History</h2>

      <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
        <select style={{ ...inputStyle, width: 180 }} value={filters.category} onChange={(e) => { setPage(1); setFilters({ ...filters, category: e.target.value }); }}>
          <option value="">All categories</option>
          <option value="positions">Positions</option>
          <option value="user_overrides">User Overrides</option>
          <option value="scope_grants">Scope Grants</option>
          <option value="timed_access">Timed Access</option>
          <option value="settings">Settings</option>
        </select>
        <input style={{ ...inputStyle, width: 200 }} placeholder="Search..." value={filters.search} onChange={(e) => { setPage(1); setFilters({ ...filters, search: e.target.value }); }} />
        <input type="date" style={{ ...inputStyle, width: 160 }} value={filters.from} onChange={(e) => { setPage(1); setFilters({ ...filters, from: e.target.value }); }} />
        <input type="date" style={{ ...inputStyle, width: 160 }} value={filters.to} onChange={(e) => { setPage(1); setFilters({ ...filters, to: e.target.value }); }} />
      </div>

      {initialLoading || !data ? <div style={{ padding: 32, textAlign: 'center' }}>Loading...</div> : (
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 18 }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Date</th>
                  <th style={thStyle}>User</th>
                  <th style={thStyle}>Category</th>
                  <th style={thStyle}>Type</th>
                  <th style={thStyle}>Action</th>
                  <th style={thStyle}>Reason</th>
                </tr>
              </thead>
              <tbody>
                {(data.data || []).map((log) => (
                  <tr key={log.id}>
                    <td style={tdStyle}>{new Date(log.created_at).toLocaleString()}</td>
                    <td style={tdStyle}>{log.user?.name || '—'}</td>
                    <td style={tdStyle}>{log.category}</td>
                    <td style={tdStyle}>{log.auditable_type}</td>
                    <td style={tdStyle}>{log.action}</td>
                    <td style={tdStyle}>{log.reason || '—'}</td>
                  </tr>
                ))}
                {(!data.data || data.data.length === 0) && <tr><td style={tdStyle} colSpan={6}>No audit history yet.</td></tr>}
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 12 }}>
            <button style={btnSecondary} disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>Previous</button>
            <span style={{ fontSize: 12, color: '#6b7280' }}>Page {data.current_page} of {data.last_page}</span>
            <button style={btnSecondary} disabled={data.current_page >= data.last_page} onClick={() => setPage((p) => p + 1)}>Next</button>
          </div>
        </div>
      )}
    </div>
  );
}
